/**
 * @file
 * Block: Search.
 */
(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.medihumBlockSearch = {
    attach: function (context, settings) {
      var self = this;
      var $context = $(context);

      $('.medihum-base-search-block-form').once('search-process').each(function () {
        var $form = $(this);
        var $reset = $('<i></i>').addClass('icon-e-remove-gray reset hidden');
        var $textfield = $form.find('input.form-text');

        $textfield.after($reset);

        $textfield.bind('blur', function () {
          self.removeSuggestions(this);
        });

        $textfield.bind('focus', function () {
          self.checkInput($textfield, $reset);
        });

        $textfield.typeWatch({
          callback: function (value) {
            self.checkInput($textfield, $reset);
          }
        });

        $('i.reset').bind('click', function () {
          $textfield.val('');
          $(this).addClass('hidden');
          self.removeSuggestions(this);
        });

        $('.medihum-base-search-block-form #edit-submit').on('click', function (event) {
          event.preventDefault();
          var val = $textfield.val();
          if (val !== '' && val.length >= 3) {
            window.location.href = '/produkty/' + encodeURI(val);
          }
        });
      });
    },
    checkInput: function (el, reset) {
      var self = this;
      var val = $(el).val();

      if (val.length) {
        $(reset).removeClass('hidden');
      }
      else {
        $(reset).addClass('hidden');
      }

      // suggestions
      var xhr;
      if (val.length >= 3) {
        if (xhr && xhr.readyState != 4) {
          xhr.abort();
        }
        var $searchProgress = $(".search-ajax-progress");
        $searchProgress.removeClass('hidden');
        xhr = $.ajax({
          url: Drupal.url('search/suggestions/') + encodeURIComponent(val)
        })
          .done(function (data) {
            self.insertSuggestions(el, data, val);
            $searchProgress.addClass('hidden');
          });
      }
      else {
        if (xhr && xhr.readyState != 4) {
          xhr.abort();
        }
        self.removeSuggestions(el);
      }
    },
    insertSuggestions: function (el, suggestions, keyword) {
      $('.search-suggestions', $(el).parent()).remove();

      if ($(el).is(':focus')) {
        clearTimeout(this.suggestionsHide);

        var $wrapper = $('<div class="search-suggestions"></div>');
        var $reset_overlay = $('<i></i>').addClass('icon-e-remove reset');
        var $more = $('<div class="more"></div>');

        var total = 0;
        var search_link = Drupal.url('produkty/' + encodeURIComponent(keyword));

        $wrapper.html(suggestions);
        $wrapper.find('.view .view-header > .count').each(function () {
          var value = $(this).text();
          if (!isNaN(parseFloat(value)) && isFinite(value)) {
            total += parseInt(value);
          }
        });

        if (total > 0) {
          var translations = Drupal.behaviors.medihumTranslation.getTranslations();

          $wrapper.find('.field--name-title, .views-field-title a, .views-field-name a').mark(keyword);
          $more.html('<a href="' + search_link + '">' + translations.showAll + '</a>');
          $wrapper.append($more);
          $wrapper.append($reset_overlay);

          $(el).parent().append($wrapper);

          $('body').addClass('disabled-scroll').addClass('search-overlay');
        }
      }
    },
    removeSuggestions: function (el) {
      clearTimeout(this.suggestionsHide);

      this.suggestionsHide = setTimeout(function () {
        $('.search-suggestions', $(el).parent()).remove();
        $('body').removeClass('search-overlay').removeClass('disabled-scroll');
      }, 250);
    }
  };

})(jQuery, Drupal);
